import { c as _c } from "react/compiler-runtime";
import type { DupeKind } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
const useDupeKindLabels = () => {
  const $ = _c(41);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "duplicateData"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t(_temp2);
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp3);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp4);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp5);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t(_temp6);
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t(_temp7);
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t(_temp8);
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t(_temp9);
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t(_temp10);
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t(_temp11);
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t) {
    t12 = t(_temp12);
    $[23] = t;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t) {
    t13 = t(_temp13);
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t1 || $[28] !== t10 || $[29] !== t11 || $[30] !== t12 || $[31] !== t13 || $[32] !== t2 || $[33] !== t3 || $[34] !== t4 || $[35] !== t5 || $[36] !== t6 || $[37] !== t7 || $[38] !== t8 || $[39] !== t9) {
    t14 = {
      ssn9: t1,
      email: t2,
      phone_number: t3,
      name_dob: t4,
      device_id: t5,
      cookie_id: t6,
      selfie: t7,
      name_ssn4: t8,
      dob_ssn4: t9,
      bank_routing_account: t10,
      card_number_cvc: t11,
      identity_document_number: t12,
      name: t13
    };
    $[27] = t1;
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
    $[32] = t2;
    $[33] = t3;
    $[34] = t4;
    $[35] = t5;
    $[36] = t6;
    $[37] = t7;
    $[38] = t8;
    $[39] = t9;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  return t14;
};
export default useDupeKindLabels;
function _temp($) {
  return $.dupeKinds.ssn9;
}
function _temp2($_0) {
  return $_0.dupeKinds.email;
}
function _temp3($_1) {
  return $_1.dupeKinds.phoneNumber;
}
function _temp4($_2) {
  return $_2.dupeKinds.nameDob;
}
function _temp5($_3) {
  return $_3.dupeKinds.deviceId;
}
function _temp6($_4) {
  return $_4.dupeKinds.cookieId;
}
function _temp7($_5) {
  return $_5.dupeKinds.selfie;
}
function _temp8($_6) {
  return $_6.dupeKinds.nameSsn4;
}
function _temp9($_7) {
  return $_7.dupeKinds.dobSsn4;
}
function _temp10($_8) {
  return $_8.dupeKinds.bankRoutingAccount;
}
function _temp11($_9) {
  return $_9.dupeKinds.cardNumberCvc;
}
function _temp12($_10) {
  return $_10.dupeKinds.identityDocumentNumber;
}
function _temp13($_11) {
  return $_11.dupeKinds.name;
}